import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VerifyPhoneNumberComponent } from '../../components/verify-phone-number/verify-phone-number.component';
import { BaseModalSize } from '@shared/ui/modal';
import { RegisterGuestRequest } from '../../models/request.models';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class PageLayoutModalService {
  ref!: DynamicDialogRef | null;

  constructor(public dialogService: DialogService) {}

  openVerifyPhoneNumber(registerRequest: RegisterGuestRequest, phoneNumber: string, userUid: string): Observable<boolean> {
    this.ref = this.dialogService.open(VerifyPhoneNumberComponent, {
      data: { registerRequest: registerRequest, phoneNumber: phoneNumber, userUid: userUid },
      width: BaseModalSize.Large,
      modal: true,
    });

    return new Observable<boolean>((observer) => {
      this.ref?.onClose.subscribe((result) => {
        observer.next(!!result);
        observer.complete();
      });
    });
  }
}
